import Cookies from 'js-cookie';
const COOKIES_MAX_AGE_IN_DAYS = 360;

const cookiesStorage = {
  async getItem(key: string) {
    return Cookies.get(key) ?? null;
  },
  async setItem(key: string, value: string) {
    Cookies.set(key, value, {
      expires: COOKIES_MAX_AGE_IN_DAYS,
      secure: process.env.NODE_ENV === 'production',
      sameSite: 'Lax',
    });
    return Promise.resolve();
  },
  async removeItem(key: string) {
    Cookies.remove(key, {
      secure: process.env.NODE_ENV === 'production',
      sameSite: 'Lax',
    });
    return Promise.resolve();
  },
};

export default cookiesStorage;
